import React, { useState, useEffect, useContext } from 'react'
import { Form, Toast } from 'antd-mobile';
import { UserContext } from 'utils/getContext'
import { onSubmitForm } from "api/api";
import { applyCertificatePage1 } from 'data/applyCertificateForm';
import { getAreaObj, getUserObj } from 'utils/getData'
import { judgeSex, userInfoHide, idCardHide } from "utils/ruleType";
import { GetFormType } from "./GetFormType";
import { FromSteps } from "./FromSteps";

/** 就业创业电子证申领 */
export function ApplyCertificate() {
  const myContext = useContext(UserContext)
  const { userInfo } = myContext
  const { name, sex, idNum } = userInfo ? userInfo : {}
  const [form] = Form.useForm();
  const [postData, setPostData] = useState({})
  const [content, setContent] = useState({});
  const [stepNum, setStepNum] = useState(1)
  const [areaContent, setAreaContent] = useState([])
  const title = ['申报信息', '提交申请']
  const pageData = [applyCertificatePage1]
  /** 对发出的参数数据【postInfo】进行处理 */
  const postInfo = userInfo && {
    ...postData,
    FNAME: name,
    FSEX: sex,
    FIDNUM: idNum,
    FTYPE: 5,
  }

  /** 对默认返回的参数进行处理后显示到页面上 */
  useEffect(() => {
    if (userInfo) {
      form.setFieldsValue({
        FNAME: idCardHide(name, 1, name.length - 1) || '',
        FSEX: judgeSex(sex),
        FIDNUM: userInfoHide(userInfo),
      });
    }
  }, [sex, name, form, userInfo, idNum]);

  /** 初始化数据 */
  useEffect(() => {
    getAreaObj('', areaContent, setAreaContent)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /** 更新提交表单接口参数数据 */
  function setFormInfo(name, value) {
    const newPostData = { ...postData }
    switch (name) {
      case 'FPERCITY':
      case 'FPERCOUNTY':
      case 'FPERPROVINCE':
        const newName = name.replace('FPER', 'F')
        newPostData[newName] = value
        break
      case 'FPERTOWN':
      case 'FPERVILLAGE':
        break
      default:
        newPostData[name] = value
    }
    setPostData(newPostData)
  }

  /** 提交表单 */
  async function handleSubmitFormClick(setLoading) {
    const params = {
      serviceId: 119,
      params: {
        T_PSM_PapeEntrCertAppl: postInfo,
      },
    };
    if (stepNum === title.length -1 ) {
      setLoading(true)
      try {
        const res = await onSubmitForm(params);
        if (res.code === 200) {
          setStepNum(stepNum + 1)
        } else {
          Toast.show({
            icon: 'fail',
            content: '提交失败，请检查内容并重试',
          })
        }
      } catch (error) {
        Toast.show({
          icon: 'fail',
          content: '提交失败，请检查内容并重试',
        })
      } finally {
        setLoading(false)
      }
    }
  }

  /** 初始化表单渲染模板 */
  const getType = (arr, index) =>
    <GetFormType
      key={index}
      item={arr}
      setFormInfo={setFormInfo}
      content={content}
      setContent={setContent}
      getUserObj={getUserObj}
      areaContent={areaContent}
      setAreaContent={setAreaContent}
      getAreaObj={getAreaObj}
    />

  return (
    <FromSteps
      stepNum={stepNum} title={title}
      getType={getType} setStepNum={setStepNum}
      form={form} pageData={pageData}
      handleSubmitFormClick={handleSubmitFormClick}
    />
  )
}